<template>
  <div class="evaluation-page">
    <van-nav-bar
      fixed
      left-arrow
      placeholder
      left-text="评价"
      @click-left="onClickLeft"
    >
      <div slot="right" class="navbar-logo-wrapper">
        <img src="@/assets/images/logo.png" alt="" class="navbar-logo">
      </div>
    </van-nav-bar>

    <div class="evaluation-page-container">
      <van-field
        class="evaluation-content-input"
        v-model="content"
        label="评价内容"
        rows="10"
        type="textarea"
        required
        placeholder="请填写评价内容(限制200个字)"
        input-align="left"
      />
    </div>

    <div class="button-wrapper">
      <van-button type="primary"
                  class="submit-button"
                  :disabled="loading"
                  @click="submit">提交</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import Evaluation from '@/apis/Evaluation';

export default {
  name: 'Evaluation',
  data() {
    return {
      loading: false,
      content: '',
    };
  },
  created() {
    document.title = '评价';
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    async submit() {
      this.loading = true;
      if (!this.content) {
        Toast.fail('评价内容不能为空！');
        return;
      }
      const toast = Toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      const data = {
        evaluation_content: this.content,
        id: this.$route.query.id,
      };
      const res = await Evaluation.submitData(data);
      console.log('res>>>>', res);
      toast.clear();
      if (+res?.code === 1) {
        Toast.success('评价提交成功！');
        setTimeout(() => {
          this.$router.back();
        }, 1500);
      } else {
        this.loading = false;
        Toast.fail(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";
@import "~@/assets/styles/variable.scss";

.navbar-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.navbar-logo {
  width: 28px;
}
::v-deep {
  .van-nav-bar {
    background-color: #196c44;
  }
  .van-nav-bar__text {
    color: #fff;
  }
}

.button-wrapper {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  @include safe-padding-bottom(20px);
  .submit-button {
    flex-grow: 1;
    background-color: rgb(69, 128, 84);
    border-color: rgb(69, 128, 84);
    box-sizing: border-box;
    margin: 20px 15px;
    border-radius: 20px;
  }
}

.evaluation-content-input {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.evaluation-page-container {
  padding: 10px;
  border-radius: 10px;
}
</style>
